import { func } from "prop-types";
import { useRef } from "react";

import styled from "styled-components";

import { useUserData } from "Flocknote/apiHooks";

import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import { useIsViewProfileFlashing } from "NavBar/stateHooks";
import { menuIconProps } from "NavBar/styleConstants";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";
import { marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import useHeight from "Utilities/Hooks/useHeight";
import flash from "Utilities/interpolations/flash";

import AppendLink from "../AppendLink";

import LogInToAnotherAccount from "./LogInToAnotherAccount";
import OtherNetworks from "./OtherNetworks";
import PublicHomeButton from "./PublicHomeButton";

const PopperContent = ({ setCloseTrigger }) => {
  const [{ userID }] = useUserData();
  const isFlashing = useIsViewProfileFlashing();
  const settingsRef = useRef(null);
  const settingsHeight = useHeight(settingsRef);

  return (
    <PopperContentWrapper>
      <OtherNetworks settingsHeight={settingsHeight} />
      <SettingsOptionsWrapper ref={settingsRef}>
        <SAppendLink
          to={`/user/${userID}`}
          data-cy="NavBar_UserButton"
          onClick={() => {
            setCloseTrigger({});
          }}
          $isFlashing={isFlashing}
          $flashToColor={addOpacity(marketingColors.lightBlue, 0.2)}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="user fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>View Profile</FnrTypography>
          </SettingsOptionWrapper>
        </SAppendLink>

        <AppendLink
          to={`/user/${userID}?profileTab=groups`}
          data-cy="NavBar_NotificationPreferences"
          onClick={() => {
            setCloseTrigger({});
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="bell fas" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>
              Notification Preferences
            </FnrTypography>
          </SettingsOptionWrapper>
        </AppendLink>

        <PublicHomeButton />
        <LogInToAnotherAccount />
      </SettingsOptionsWrapper>
    </PopperContentWrapper>
  );
};

PopperContent.propTypes = { setCloseTrigger: func };

const PopperContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SAppendLink = styled(AppendLink)`
  border-radius: 8px;
  ${flash}
`;

export default PopperContent;
